import type { PlatformComponentProps } from "@b2bportal/core-types";
import { HotelNavigationFlow, HotelSteps } from "@b2bportal/core-utilities";
import { ShopPage, useShopPage, useShopPageRoute } from "@tenant/hotels";

export const ShopPageRoute = ({
  className,
  children,
}: PlatformComponentProps) => {
  const params = useShopPageRoute();

  const goToNextStep = HotelNavigationFlow.useGoToNextStep(HotelSteps.SHOP);

  const data = useShopPage({ ...params, goToNextStep });
  return (
    <ShopPage {...data} className={className}>
      {children}
    </ShopPage>
  );
};
